import { AfterViewInit, Component, ElementRef, Input, OnDestroy, ViewChild } from '@angular/core';
import Chart from 'chart.js/auto';

@Component({
  selector: 'app-line-chart',
  templateUrl: './line-chart.component.html',
  styleUrls: ['./line-chart.component.css']
})
export class LineChartComponent implements AfterViewInit, OnDestroy {
  public chart: any;

  @Input() config: any;
  @Input() mychart: any;
  @ViewChild('propio') propio?: ElementRef<HTMLCanvasElement>;

  constructor() { }

  // Se crea UNA vez, cuando el canvas ya existe. Antes se creaba en ngOnInit y otra
  // vez en ngAfterViewInit: Chart.js avisaba «canvas reused» y el canvas propio
  // mostraba el objeto como texto («[object Object]»).
  ngAfterViewInit(): void {
    this.createChart();
  }

  ngOnDestroy(): void {
    this.chart?.destroy();
  }

  createChart(): void {
    const lienzo = this.mychart || this.propio?.nativeElement;
    if (!lienzo || !this.config) return;
    this.chart?.destroy();
    this.chart = new Chart(lienzo, this.config);
  }
}
